<template>
  <div class="mobile-honorswiper-box">
    <el-carousel indicator-position="outside" arrow="never" height="26.68rem">
      <el-carousel-item v-for="(item, index) in list" :key="index">
        <div class="mobile-honorswiper-wrap">
          <div class="mobile-honorswiper-item" v-for="(sitem, sindex) in item" :key="sindex">
            <div class="mobile-icon-box">
              <img :src="getImgUrl(sitem.thumb)" class="mobile-icon hvr-grow" alt="" />
            </div>
            <div class="mobile-title">{{ sitem.title }}</div>
            <div class="mobile-honorswiper-text">{{ sitem.describe || "" }}</div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  methods: {
    getImg(page, index) {
      console.log("getImg", page, index);
      return require(`@/assets/about/certificate${(page - 1) * 4 + index}.png`);
    },
    getName(page, index) {
      if (page === 1) {
        switch (index) {
          case 1:
            return "高新技术企业证书";
          case 2:
            return "质量管理体系认证证书";
          case 3:
            return "国际分类：9";
          case 4:
            return "国际分类：38";
        }
      } else {
        return "国际分类：42";
      }
    },
    getText(index) {
      switch (index) {
        case 1:
          return "资质证书";
        case 2:
          return "资质证书";
        case 3:
          return "商标注册证";
        case 4:
          return "商标注册证";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>
